{
  "back": "ย้อนกลับ",
  "form": "แบบฟอร์ม",
  "purposeTitle": "วัตถุประสงค์ของการแวะจอดครั้งนี้คืออะไร",
  "appointmentInfoTitle": "ข้อมูลการนัดหมาย",
  "appointmentInfoHint": "โปรดกรอกช่องนี้หากคุณมีการนัดหมาย",
  "checkInDetailsTitle": "รายละเอียดการเช็กอิน",
  "checkInDetailsHint": "ข้อมูลเพิ่มเติมเกี่ยวกับการเข้ามาของคุณ",
  "driverPhoneLabel": "หมายเลขโทรศัพท์ของคนขับ",
  "activateWhatsAppTitle": "เปิดใช้งานการส่งข้อความทาง WhatsApp",
  "activateWhatsAppBody": "หากต้องการแชทกับคลังสินค้า โปรดตอบกลับ \"OK\" เมื่อเราส่งข้อความ WhatsApp ข้อความแรกถึงคุณ",
  "whatsappDelayBanner": "ข้อความ WhatsApp ข้อความแรกอาจใช้เวลาถึงหนึ่งนาทีกว่าจะมาถึง",
  "notesLabel": "หมายเหตุ",
  "notesPlaceholder": "มีคำแนะนำพิเศษหรือหมายเหตุถึงสถานที่หรือไม่",
  "verifyAndCheckIn": "ยืนยันและเช็กอิน",
  "completeCheckIn": "เช็กอินให้เสร็จสมบูรณ์",
  "visitGroupInbound": "ขาเข้า",
  "visitGroupOutbound": "ขาออก",
  "visitGroupBoth": "ขาเข้าและขาออก",
  "visitUnloadTruck": "ขนสินค้าลงจากรถบรรทุกของฉัน",
  "visitDropTrailer": "ปลดรถพ่วงหรือตู้คอนเทนเนอร์ของฉัน",
  "visitLoadTruck": "ขนสินค้าขึ้นรถบรรทุกของฉัน",
  "visitHookTrailer": "ต่อพ่วงรถพ่วงหรือตู้คอนเทนเนอร์",
  "visitUnloadLoad": "ขนสินค้าลงและขึ้นรถบรรทุกของฉัน",
  "visitDropHook": "ปลดและต่อพ่วงรถพ่วงหรือตู้คอนเทนเนอร์",
  "containerTrailer": "รถพ่วง",
  "containerContainer": "ตู้คอนเทนเนอร์",
  "containerOversized": "ขนาดใหญ่พิเศษ",
  "containerOther": "อื่น ๆ",
  "defaultReferenceName": "หมายเลขใบสั่งซื้อ (PO Number)",
  "identifierSuffix": "{reference} หรือหมายเลขยืนยัน",
  "licenseOrDotRequired": "โปรดกรอกป้ายทะเบียนหรือหมายเลข DOT",
  "appointmentNotFound": "เราไม่พบการนัดหมายของคุณ",
  "referenceNotFound": "ไม่พบการนัดหมายที่ตรงกัน หมายเลขอ้างอิงจะแยกตัวพิมพ์เล็กและพิมพ์ใหญ่",
  "referenceCaseSensitiveHint": "หมายเลขอ้างอิงจะแยกตัวพิมพ์เล็กและพิมพ์ใหญ่",
  "messaging": {
    "whatsappFailedTitle": "ไม่สามารถส่งข้อความ WhatsApp ได้",
    "smsFailedTitle": "ไม่สามารถส่งข้อความ SMS ได้",
    "whatsappFailedBody": "เราไม่สามารถส่งข้อความถึง {displayPhone} ได้ <br /><br /> หากคุณเคยยกเลิกการรับข้อความ โปรดส่งข้อความ START ไปที่ <a href='{waUrl}' target='_blank' rel=\"noopener noreferrer\">{senderPhone}</a> เพื่อเริ่มรับข้อความจากคลังสินค้านี้อีกครั้ง",
    "smsFailedBody": "เราไม่สามารถส่งข้อความถึง {displayPhone} ได้ <br /><br /> หากคุณเคยยกเลิกการรับข้อความ โปรดส่งข้อความ START ไปที่ <a href='{smsUrl}'>{senderPhone}</a> เพื่อเริ่มรับข้อความ SMS จากคลังสินค้านี้อีกครั้ง",
    "fallbackPhone": "หมายเลขโทรศัพท์ที่ระบุ"
  }
}
